export default "__VITE_ASSET__DXBzuXPN__"